import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import Strings from "@my-dld/assets/strings";
import { AuditedRVRequest, RVSearchQuery } from "../../../api/entities";
import * as RVApi from "../../../api/api";
import { RVRequestSearchResult } from "../../../api/api";
import { getParticipantID } from "@10x/sso";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import RVRequestsListView from "./RVRequestsListView";
import { DateUtil, LocaleUtil } from "@eres/core";
import RVRequestsGridView from "./RVRequestsGridView";
import { showRVRequestDetails } from "../../../NavigationUtils";
import { populateRVStatus } from "../../../RVUtils";

interface Props extends RoutedViewProps {

}

interface State {
	isLoading: boolean;
	requests: AuditedRVRequest[];
	startIndex: number;
	totalRows: number;
}

class RVRequests extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			requests: [],
			startIndex: 0,
			totalRows: 0,
		};
	}

	componentDidMount() {
		this.loadRVRequests();
	}

	render() {
		const { isLoading, totalRows } = this.state;
		return <ListGridDataView
			isLoading={ isLoading }
			dataAvailable={ totalRows > 0 }
			title={ Strings.rental_evaluation_requests }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }
			totalCount={ totalRows }
			onPageChange={ this.onPageChange }/>;
	}

	private renderListView = () => {
		const { requests } = this.state;
		return <RVRequestsListView
			requests={ requests }
			onDetails={ this.onRequestDetails }/>;
	};

	private renderGridView = () => {
		const { requests } = this.state;
		return <RVRequestsGridView
			requests={ requests }
			onDetails={ this.onRequestDetails }/>;
	};

	private onPageChange = ( pageIndex: number ) => {
		showLoading();
		this.setState( {
			startIndex: ( pageIndex - 1 ),
		}, () => {
			this.loadRVRequests();
		} );
	};

	private loadRVRequests() {
		const { startIndex } = this.state;
		const request: RVSearchQuery = {
			PageSize: 20,
			PageIndex: startIndex,
			ParticipantId: getParticipantID()
		} as RVSearchQuery;
		RVApi.searchRVRequest( request ).then( RVApi.validateResponse )
		.then( ( response: RVRequestSearchResult ) => {
			this.setState( {
				isLoading: false,
				requests: response.Data,
				totalRows: response.TotalRecords,
			} );
			hideLoading();
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}

	private onRequestDetails = ( request: AuditedRVRequest ) => {
		if ( request.RequestNumber )
			showRVRequestDetails( request.RequestNumber );
	};

}

export function getRVReqPropertyType( request: AuditedRVRequest ) {
	if ( request.Properties && request.Properties.length > 0 ) {
		const p = request.Properties[ 0 ];
		return LocaleUtil.getLocalValue( { en: p.PropertyTypeNameEn, ar: p.PropertyTypeNameEn } );
	}
	return "-";
}

export function getRVReqPropertyTypeID( request: AuditedRVRequest ) {
	if ( request.Properties && request.Properties.length > 0 ) {
		const p = request.Properties[ 0 ];
		return p.PropertyTypeId;
	}
	return 1;
}

export function getRVReqArea( request: AuditedRVRequest ) {
	if ( request.Properties && request.Properties.length > 0 ) {
		const p = request.Properties[ 0 ];
		return LocaleUtil.getLocalValue( { en: p.AreaNameEn, ar: p.AreaNameAr } );
	}
	return "-";
}

export function getRVReqDate( request: AuditedRVRequest ) {
	return request.RequestOn ? DateUtil.formatDate( request.RequestOn.asDate(), "DD/MM/YYYY", "en" ) : "-";
}

export function getRVReqStatus( request: AuditedRVRequest ) {
	populateRVStatus( request );
	return request.Status ? LocaleUtil.getLocalValue( request.Status ) : "-";
}

export default RVRequests;
